import { Button, Card, Form, Spinner } from "react-bootstrap";
import { IWarehouse } from "../../api/types";
import { usePutWarehouseMutation } from "../../api/putWarehouse.mutation";
import { useEffect, useRef, useState } from "react";

export const WarehouseForm = (props: { warehouse?: IWarehouse, onSave?:(warehouse: IWarehouse)=> void, onClose: () => void }) => {
  const { warehouse: warehouseInput } = props;
  const [warehouse, setWarehouse] = useState<Partial<IWarehouse>>({...warehouseInput});
  const { mutate: putWarehouse, isPending, isError, isSuccess } = usePutWarehouseMutation();
  const inputRef = useRef<HTMLInputElement>(null);
  const updateField = (key: keyof IWarehouse, value: any) => setWarehouse({ ...warehouse, [key]: value });

  useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

  const onSubmit: React.MouseEventHandler<HTMLButtonElement> = (event) => {
    event.preventDefault()
    if(props.onSave) {
      props.onSave(warehouse as IWarehouse);
    } else {
      putWarehouse(warehouse as IWarehouse);
    }
    props.onClose();
  }

  if(isSuccess) props.onClose();

  return <Card>
    <Card.Header>
      {warehouse?.id ? "Edit Warehouse" : "Create Warehouse"}
    </Card.Header>
    <Card.Body>
      <Form>
        <Form.Group>
          <Form.Label>Warehouse Name</Form.Label>
          <Form.Control
            type="text" placeholder="Warehouse Name"
            defaultValue={warehouse?.name}
            onChange={(e) => updateField('name', e.target.value)}
            ref={inputRef}
          />
        </Form.Group>
      </Form>
    </Card.Body>
    <Card.Footer>
      {isError && <Card.Text className="text-danger">Error</Card.Text>}
      {isPending ? <Spinner /> :
        <Button onClick={onSubmit}>{warehouse?.id ? "Update" : "Create"}</Button>
      }
    </Card.Footer>
  </Card>
}